export enum API_VARIABLES {
  PERSON_ID = '{personId}'
}

export const MYINFO_API = {
  GET_PERSONINFORMATION_BYID: 'person/info/{personId}',
  UPDATE_PERSONINFORMATION: 'person/info/{personId}',
}